// src/features/terreni/terreniSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  terreni: [],
  singleTerreni:{},
  esposizione: [],
  tipoSuolo: [],
  sistemaColtivazione: [],
  cultura: [],
  uliveto: [],
  varieta: [],
  isLoading: false,
  error: null,
  enumsLoading: {
    esposizione: false,
    tipoSuolo: false,
    sistemaColtivazione: false,
    uliveto: false,
    cultura: false,
    varieta: false
  },
  enumsError: {
    esposizione: null,
    tipoSuolo: null,
    sistemaColtivazione: null,
    cultura: null,
    uliveto: null,
    varieta: null
  }
};

const terreniSlice = createSlice({
  name: "terreni",
  initialState,
  reducers: {
    // Terreni data management
    setTerreni: (state, action) => {
      state.terreni = action.payload;
    },
    addTerreni: (state, action) => {
      state.terreni.push(action.payload);
    },
    addTerreniId: (state, action) => {
      console.log(action.payload,"action.payload")
      state.singleTerreni=action.payload
    },
    updateTerreni: (state, action) => {
      const index = state.terreni.findIndex(terreno => terreno.id === action.payload.id);
      if (index !== -1) {
        state.terreni[index] = action.payload;
      }
    },
    removeTerreni: (state, action) => {
      state.terreni = state.terreni.filter(
        (terreno) => terreno.id !== action.payload
      );
    },

    // API request states
    apiRequestStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    apiRequestSuccess: (state) => {
      state.isLoading = false;
    },
    apiRequestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    // Enums management
    setEsposizione: (state, action) => {
      state.esposizione = action.payload;
    },
    setTipoSuolo: (state, action) => {
      state.tipoSuolo = action.payload;
    },
    setSistemaColtivazione: (state, action) => {
      state.sistemaColtivazione = action.payload;
    },
    

    setCultura: (state, action) => {
      state.cultura = action.payload;
    },
    setUliveto: (state, action) => {
      state.uliveto = action.payload;
    },
    setVarieta: (state, action) => {
      state.varieta = action.payload;
    },


    // Enum loading states
    enumRequestStart: (state, action) => {
      state.enumsLoading[action.payload] = true;
      state.enumsError[action.payload] = null;
    },
    enumRequestSuccess: (state, action) => {
      state.enumsLoading[action.payload] = false;
    },
    enumRequestFailure: (state, action) => {
      const { enumType, error } = action.payload;
      state.enumsLoading[enumType] = false;
      state.enumsError[enumType] = error;
    }
  },
});

// Export actions
export const {
  // Terreni actions
  setTerreni,
  addTerreni,
  addTerreniId,
  updateTerreni,
  removeTerreni,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure,
  
  // Enum actions
  setEsposizione,
  setTipoSuolo,
  setSistemaColtivazione,

  setCultura,
  setUliveto,
  setVarieta,

  enumRequestStart,
  enumRequestSuccess,
  enumRequestFailure,
} = terreniSlice.actions;

// Export selectors
export const selectTerreni = (state) => state.terreni.terreni;
export const selectIsLoading = (state) => state.terreni.isLoading;
export const selectError = (state) => state.terreni.error;

// Enum selectors
export const selectEsposizione = (state) => state.terreni.esposizione;
export const selectTipoSuolo = (state) => state.terreni.tipoSuolo;
export const selectSistemaColtivazione = (state) => state.terreni.sistemaColtivazione;

export const selectCultura = (state) => state.terreni.cultura;
export const selectUliveto = (state) => state.terreni.uliveto;
export const selectVarieta = (state) => state.terreni.varieta;


export default terreniSlice.reducer;